/* eslint-disable react/prop-types */
import * as React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import Iframe from 'react-iframe';

export const PurchaseForm = ({ url, onCancel }) => (
  <>
    <Modal
      open
      size='fullscreen'
      style={{ right: 0 }}
      closeOnDimmerClick={false}
      closeIcon={false}
      onClose={onCancel}
    >
      <Modal.Content>
        <Iframe
          url={url}
          width='100%'
          height='700px'
          display='initial'
          position='relative'
        />
      </Modal.Content>
      <Modal.Actions>
        <Button primary content='Close' onClick={onCancel} />
      </Modal.Actions>
    </Modal>
  </>
);
